import {SelectContent, SelectItem, SelectTrigger, SelectValue, Select as ShadeSelect} from '@tryghost/shade';
import {useId} from 'react';
import type {ReactNode} from 'react';

interface SelectOption {
    value: string;
    label: string;
    description?: string;
    disabled?: boolean;
}

interface SelectProps {
    value?: string;
    defaultValue?: string;
    onChange?: (value: string) => void;
    options: SelectOption[];
    placeholder?: string;
    disabled?: boolean;
    width?: number | string;
    id?: string;
    name?: string;
    required?: boolean;
    ariaLabel?: string;
    ariaLabelledBy?: string;
    className?: string;
    renderOption?: (option: SelectOption) => ReactNode;
}

export function Select({
    value,
    defaultValue,
    onChange,
    options,
    placeholder,
    disabled = false,
    width = 'auto',
    id,
    name,
    required,
    ariaLabel,
    ariaLabelledBy,
    className = '',
    renderOption
}: SelectProps) {
    const generatedId = useId();
    const triggerId = id || generatedId;
    const emptyOption = options.find(option => option.value === '');

    return <ShadeSelect
        defaultValue={defaultValue}
        disabled={disabled}
        name={name}
        required={required}
        value={value}
        onValueChange={onChange}
    >
        <SelectTrigger
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledBy}
            className={`studio-select-trigger ${className}`.trim()}
            id={triggerId}
            style={{width}}
        >
            <SelectValue placeholder={placeholder || emptyOption?.label || 'Select…'} />
        </SelectTrigger>
        <SelectContent className="studio-select-content" style={{zIndex: 10000}}>
            {options.filter(option => option.value !== '').map(option => <SelectItem key={option.value} disabled={option.disabled} textValue={option.label} value={option.value}>
                {renderOption ? renderOption(option) : option.label}
            </SelectItem>)}
        </SelectContent>
    </ShadeSelect>;
}
